module.exports = __webpack_public_path__ + "img/ic_comment.11aeb3aa.svg";